import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'
import { SET_AUTHENTICATION, SET_USER_DETAILS } from './actionTypes'

const initialState = {
  auth: {
    accessToken: null,
    isAuthenticated: false,
    refreshToken: null,
    hasCheckedAuthentication: false,
  },
  user: {
    id: null,
    firstName: null,
    lastName: null,
    email: null,
    goustoReference: null,
  },
}

const store = createContext(initialState)
const { Provider } = store

const StateProvider = ({ children, overrideDispatch }) => {
  const [state, originalDispatch] = useReducer((currentState, action) => {
    switch (action.type) {
      case SET_AUTHENTICATION: {
        const newState = {
          ...currentState,
          auth: {
            ...currentState.auth,
            ...action.payload,
          },
        }

        return newState
      }
      case SET_USER_DETAILS: {
        const newState = {
          ...currentState,
          user: {
            ...currentState.user,
            ...action.payload,
          },
        }

        return newState
      }
      default:
        throw new Error('Invalid action type')
    }
  }, initialState)

  const dispatch = overrideDispatch || originalDispatch

  return (
    <Provider value={{ state, dispatch }}>
      {children}
    </Provider>
  )
}

StateProvider.propTypes = {
  children: PropTypes.node.isRequired,
  overrideDispatch: PropTypes.func,
}

StateProvider.defaultProps = {
  overrideDispatch: null,
}

export { store, StateProvider, initialState }
